import Cid10Item from './Cid10Item';

export default Cid10Item;
